
<div class="table-container">
  <table>
    <thead>
      <tr>
        <th class="item-cell">
          <div>Item</div>
        </th>

        <th
          v-for="field in fields"
          :key="field.value"
          class="sort-cell"
          @click="sortItems(field.value)"
        >
          <div>
            <icon
              v-show="field.value === sort"
              :name="descending ? 'arrow_downward' : 'arrow_upward'"
            />

            <span>{{ field.label }}</span>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="item in itemList"
        :key="item.id"
        :style="{ '--graph-color': item.color }"
      >
        <td class="item-cell">
          <router-link v-if="type === 'cards'" class="item" :to="{ path: '/compare', query: { ...$route.query, cardId: item.id } }">
            <div class="card-item-details">
              <card-image :image-url="item.image" />

              <card-item-info :card="item">
                <icon-button
                  icon="delete_outline"
                  @click.stop.prevent="$emit('removeItem', item.id)"
                />
              </card-item-info>
            </div>
          </router-link>

          <div v-if="type === 'indexes'" class="item">
            <div class="index-item-details">
              <index-image :index="item" />

              <div class="label">
                {{ item.label }}
              </div>

              <icon-button
                icon="delete_outline"
                @click.stop.prevent="$emit('removeItem', item.id)"
              />
            </div>
          </div>
        </td>

        <td
          v-for="field in fields"
          :key="field.value"
          :class="{ success: item[`${field.value}Success`], error: item[`${field.value}Error`] }"
        >
          {{ item[`${field.value}Display`] }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
